import { Button, Col, Form, Input, Radio, Row } from "antd";
import React from "react";
import { getMappedData } from "../util";

export default function CurrentImpact() {
  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Form.Item
            name="currentImpact_1"
            label={getMappedData("currentImpact_1")}
            rules={[{ required: true, message: "Please specify" }]}
          >
            <Input.TextArea rows={4} placeholder="Enter your answers here" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
      <Col xs={24} xl={24}>
          <Form.Item
            name="currentImpact_2"
            label={getMappedData("currentImpact_2")}
            rules={[{ required: true, message: "Please specify" }]}
          >
            <Input.TextArea rows={4} placeholder="Enter your answers here" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Form.Item
            name="currentImpact_3"
            label={getMappedData("currentImpact_3")}
            rules={[{ required: true, message: "Please specify" }]}
          >
            <Input.TextArea rows={4} placeholder="Enter your answers here" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="currentImpact_4"
              label={getMappedData("currentImpact_4")}
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="currentImpact_5"
              label={getMappedData("currentImpact_5")}
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="currentImpact_6"
              label={getMappedData("currentImpact_6")}
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="currentImpact_7"
              label={getMappedData("currentImpact_7")}
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="currentImpact_8"
              label={getMappedData("currentImpact_8")}
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="currentImpact_9"
              label={getMappedData("currentImpact_9")}
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
            <Form.Item
              name="currentImpact_10"
              label={getMappedData("currentImpact_10")}
              rules={[{ required: true, message: "Please specify" }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your answers here" />
            </Form.Item>
          </Col>
      </Row>
    </>
  );
}
